import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils/cn';

const inputVariants = cva(
  'flex w-full border border-input bg-transparent shadow-xs transition-colors file:border-0 file:bg-transparent file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      sizesx: {
        default: 'h-9 rounded-lg px-4 py-1 text-base file:text-sm',
        sm: 'h-8 rounded-lg px-4 py-0.5 text-sm file:text-xs',
      },
    },
    defaultVariants: {
      sizesx: 'default',
    },
  },
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, sizesx, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        className={cn(inputVariants({ sizesx, className }))}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export { Input, inputVariants };
